module.exports = __webpack_public_path__ + "static/media/siddharth-nandi-hills-trip-02.a09ba1e4.png";